export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6754.7fd77c37.jpg";